import Community from '@/features/landing/community'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/community')({
  component: Community,
})
